var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2629 20.344L20.344 14.2629C21.1361 13.4709 21.532 13.0746 21.6803 12.6179C21.8109 12.2162 21.8109 11.7844 21.6803 11.3827C21.532 10.926 21.1361 10.5291 20.344 9.73711L14.2616 3.65465C13.4704 2.86351 13.0748 2.46786 12.6184 2.31957C12.2167 2.18905 11.7839 2.18905 11.3822 2.31957C10.9257 2.46788 10.529 2.86462 9.7376 3.65599L3.65648 9.73711L3.656 9.73802C2.86429 10.5297 2.46791 10.9261 2.31957 11.3827C2.18905 11.7844 2.18905 12.2162 2.31957 12.6179C2.46786 13.0743 2.864 13.4704 3.65514 14.2616L9.74136 20.3478C10.5309 21.1373 10.9262 21.5327 11.3822 21.6808C11.7839 21.8113 12.2167 21.8113 12.6184 21.6808C13.0749 21.5325 13.4706 21.1368 14.2621 20.3453L14.2629 20.344Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstance);
export default __webpack_public_path__ + "static/media/Instance.600331b34a4399b9e9b967ea3a401f88.svg";
export { ForwardRef as ReactComponent };